import ExerciseFeedback from './ExerciseFeedback';

export default ExerciseFeedback;
